// The functions here are taken from the Polyh library, which is a simple library used for polygon validation.
// See here: https://github.com/martywallace/polyk/blob/master/dist/polyk.js#L7

/**
 * Checks, if polygon is simple. Polygon is simple, when its edges don't cross each other.
 *
 * @param {number[]} polygon [x1, y1, x2, y2...]
 * @returns {boolean} true if Polygon is simple
 */
export function IsSimple(polygon) {
  const p = polygon
  const n = p.length >> 1
  if (n < 4) return true
  const a1 = Point()
  const a2 = Point()
  const b1 = Point()
  const b2 = Point()
  const c = Point()

  for (let i = 0; i < n; i++) {
    a1.x = p[2 * i]
    a1.y = p[2 * i + 1]
    if (i == n - 1) {
      a2.x = p[0]
      a2.y = p[1]
    } else {
      a2.x = p[2 * i + 2]
      a2.y = p[2 * i + 3]
    }

    for (let j = 0; j < n; j++) {
      if (Math.abs(i - j) < 2) continue
      if (j == n - 1 && i == 0) continue
      if (i == n - 1 && j == 0) continue

      b1.x = p[2 * j]
      b1.y = p[2 * j + 1]
      if (j == n - 1) {
        b2.x = p[0]
        b2.y = p[1]
      } else {
        b2.x = p[2 * j + 2]
        b2.y = p[2 * j + 3]
      }

      if (GetLineIntersection(a1, a2, b1, b2, c) != null) return false
    }
  }
  return true
}

/**
 * Get Line Intersection
 *
 * @private
 * @param {Point} a1
 * @param {Point} a2
 * @param {Point} b1
 * @param {Point} b2
 * @param {Point} c
 * @returns {Point}
 */
const GetLineIntersection = (a1, a2, b1, b2, c) => {
  const dax = a1.x - a2.x
  const dbx = b1.x - b2.x
  const day = a1.y - a2.y
  const dby = b1.y - b2.y

  const den = dax * dby - day * dbx

  if (den === 0) {
    return null
  } // parallel

  const A = a1.x * a2.y - a1.y * a2.x
  const B = b1.x * b2.y - b1.y * b2.x

  const I = c
  I.x = (A * dbx - dax * B) / den
  I.y = (A * dby - day * B) / den

  if (InRectangle(I, a1, a2) && InRectangle(I, b1, b2)) {
    return I
  }
  return null
}

/**
 * In Rectangle
 *
 * @private
 * @param {Point} a
 * @param {Point} b
 * @param {Point} c
 * @return {boolean}
 */
function InRectangle(a, b, c) {
  const minx = Math.min(b.x, c.x)
  const maxx = Math.max(b.x, c.x)
  const miny = Math.min(b.y, c.y)
  const maxy = Math.max(b.y, c.y)

  if (minx === maxx) {
    return miny <= a.y && a.y <= maxy
  }
  if (miny === maxy) {
    return minx <= a.x && a.x <= maxx
  }

  // return (minx <= a.x && a.x <= maxx && miny <= a.y && a.y <= maxy)
  return (
    minx <= a.x + 1e-10 &&
    a.x - 1e-10 <= maxx &&
    miny <= a.y + 1e-10 &&
    a.y - 1e-10 <= maxy
  )
}

function Point(x?, y?) {
  return {
    x: x,
    y: y,
    flag: false,
    toString: function () {
      return 'Point [' + x + ', ' + y + ']'
    },
  }
}
